const config = {
  test: {
    stock: {
      sinaBaseURL: 'http://touzi.sina.com.cn/api/openapi.php',
      // proxyBaseURL: 'http://ywa-sina-proxy.api-zq-dev.baidao.com/build',
      proxyBaseURL: ' http://kong-http.api-zq-dev.baidao.com/sina-proxy/build',
      apiBaseURL: 'http://139.196.240.58:3800/api',
      appBaseURL: 'http://139.196.240.58:3002',
      // decodeBaseURL: 'http://ywa-sina-proxy.api-zq-dev.baidao.com/decode',
      decodeBaseURL: ' http://kong-http.api-zq-dev.baidao.com/sina-proxy/decode',
      // accumulateBaseURL: 'http://ywa-sina-proxy.api-zq-dev.baidao.com/accumulate'
      accumulateBaseURL: ' http://kong-http.api-zq-dev.baidao.com/sina-proxy/accumulate',
      stockStatisticsURL: 'http://139.196.240.58:3003'
    },
    businessApi: { // business 后端
      baseURL: 'http://kong-http.api-zq-dev.baidao.com/gmg-biz/v1'
    },
    marketProxy: {
      baseURL: 'http://kong-http.api-zq-dev.baidao.com/gmg-market'
    }
  },
  production: {
    stock: {
      sinaBaseURL: 'https://touzi.sina.com.cn/api/openapi.php',
      // proxyBaseURL: 'https://ywa-sina-proxy.baidao.com/build',
      proxyBaseURL: 'https://xlggapi.sinagp.com/sina-proxy/build',
      apiBaseURL: 'https://xltg-api.baidao.com/api',
      appBaseURL: 'https://xltg-stock.baidao.com',
      // decodeBaseURL: 'https://ywa-sina-proxy.baidao.com/decode',
      decodeBaseURL: 'https://xlggapi.sinagp.com/sina-proxy/decode',
      // accumulateBaseURL: 'https://ywa-sina-proxy.baidao.com/accumulate'
      accumulateBaseURL: 'https://xlggapi.sinagp.com/sina-proxy/accumulate',
      stockStatisticsURL: 'https://xltg-admin.baidao.com'
    },
    businessApi: {
      baseURL: 'https://xlggapi.sinagp.com/gmg-biz/v1'
    },
    marketProxy: {
      baseURL: 'https://xlggapi.sinagp.com/gmg-market'
    }
  }
}

export default config[window.env]



// WEBPACK FOOTER //
// ./src/config.js